import { createFileRoute, redirect } from "@tanstack/react-router";

// Slugs are unchanged, so old deep links resolve to the same FAQ answer.
export const Route = createFileRoute("/help/$section/$article")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/faq/$category/$article",
      params: { category: params.section, article: params.article },
    });
  },
});
